import type { ReactNode } from 'react'
import { Help } from '@/components/Form'
import { Sentence, SentenceText } from '@/features/legends/components/Sentence'
import {
  type Choice,
  ChoiceSelect,
} from '@/features/legends/components/ChoiceSelect'
import type { ConjunctionOperator } from '@/features/legends/filters/rules'
import styles from './ConjunctionFilter.module.css'

export interface ConjunctionFilterProps {
  op: ConjunctionOperator
  onOpChange: (op: ConjunctionOperator) => unknown
  /**
   * The sub-filters' builder.
   */
  children?: ReactNode
  error?: string
  isDisabled?: boolean
  testId?: string
}

const ops: Choice<ConjunctionOperator>[] = [
  ['All', 'Matches ALL'],
  ['Any', 'Matches ANY'],
]

/**
 * Passes when all, or any, of the sub-filters pass.
 */
export function ConjunctionFilter({
  op,
  onOpChange,
  children,
  error,
  isDisabled,
  testId,
}: ConjunctionFilterProps) {
  return (
    <div className={styles.root}>
      <Sentence>
        <ChoiceSelect
          value={op}
          choices={ops}
          onChange={onOpChange}
          isDisabled={isDisabled}
          size="small"
          aria-label="Conjunction"
          testId={testId && `${testId}-operation`}
        />
        <SentenceText>of the following sub-filters</SentenceText>
      </Sentence>
      <div className={styles.nested}>{children}</div>
      <Help error={error} />
    </div>
  )
}
